import React, { useEffect, useState } from "react";

import Dropdown from "../Dropdown";
import { useSelector } from "react-redux";
import { getCookie } from "cookies-next";
import { sortSizes } from "@/helpers/pdpHelpers";

export default function GiftSizeDropdown({
  sizeVariants,
  selectedSize,
  setSelectedSize,
  showStickyDropdown,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
}) {
  let sizeData = [];
  let disabled = [];
  let dropdownTitle = selectedSize ? "Selected amount : " : "Select gift amount";
  for (const size in sizeVariants) {
    if (sizeVariants.hasOwnProperty(size)) {
      if(parseInt(sizeVariants[size].priceV2.amount)!=0)
      {
        sizeData.push(size); 
      }
      if (!sizeVariants[size].availableForSale) disabled.push(size);
    }
  }
  
  sortSizes(sizeData);
  
  const handleDropdownToggle = (e) => {
    setIsSizeDropdownOpen(e);
  };

  const handleOutsideClick = () => {
    setIsSizeDropdownOpen(false);
  };

  const [loading, setLoading] = useState(false);

  const isWishlistLoading = useSelector(
    (state) => state.wishlist.loading_status
  );

  useEffect(() => {
    if (isWishlistLoading) {
      if (getCookie("isFavourite")) {
        setLoading(true);
      }
    } else {
      setLoading(false);
    }
  }, [isWishlistLoading]);

  return (
    <>
      {(
        <Dropdown
          ArrowDown="images/Icons/Chevron/large.svg"
          data={sizeData}
          disabled={disabled}
          selected={selectedSize}
          setSelected={setSelectedSize}
          showStickyDropdown={showStickyDropdown}
          isDropdownOpen={isSizeDropdownOpen}
          parentHandleToggle={handleDropdownToggle}
          isDropup={false}
          handleOutsideClick={handleOutsideClick}
          dropdownTitle={dropdownTitle}
          loading={loading}
        />
      )}
    </>
  );
}
